import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'boulder',
      d: 'M5,-0.5h1v1h-1zM3,0h0.5v0.5h-0.5zM-5.5,0.5h2v0.5h-2zM-1,0.5h1.5v0.5h-1.5zM1,0.5h0.5v0.5h-0.5zM2.5,0.5h3.5v0.5h-3.5zM-4.5,1h10.5v0.5h-10.5zM-3,1.5h7v0.5h-7z',
    },
    {
      paint: 'rock',
      d: 'M0.5,-2h0.5v0.5h-0.5zM-5,-1.5h1v0.5h-1zM-2.5,-1.5h1.5v1.5h-1.5zM0.5,-1.5h1.5v2h-1.5zM-5.5,-1h1.5v0.5h-1.5zM3,-1h0.5v1h-0.5zM5,-1h0.5v0.5h-0.5zM-6,-0.5h1.5v0.5h-1.5zM-6,0h1v0.5h-1zM-4,0h3v0.5h-3zM2.5,0h0.5v0.5h-0.5zM-3.5,0.5h2.5v0.5h-2.5zM0.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'coral',
      d: 'M-4,-8h1.5v2.5h-1.5zM-5.5,-7.5h0.5v0.5h-0.5zM-6,-7h1.5v1.5h-1.5zM-1.5,-7h1v1h-1zM-2,-6h1.5v1h-1.5zM-5.5,-5.5h3v0.5h-3zM-5.5,-5h5v0.5h-5zM-5,-4.5h4v0.5h-4zM-4,-4h2.5v0.5h-2.5zM-4,-3.5h1.5v3.5h-1.5zM-1,-1.5h0.5v2h-0.5z',
    },
    {
      paint: 'epicMagic',
      d: 'M2,-9h0.5v0.5h-0.5zM0,-8.5h1v0.5h-1zM1.5,-8.5h1.5v0.5h-1.5zM0,-8h5v0.5h-5zM0,-7.5h2v1h-2zM2.5,-7.5h2.5v0.5h-2.5zM2.5,-7h3v0.5h-3zM-0.5,-6.5h2.5v0.5h-2.5zM3,-6.5h0.5v0.5h-0.5zM4,-6.5h1.5v1.5h-1.5zM-0.5,-6h1.5v0.5h-1.5zM-0.5,-5.5h2v0.5h-2zM0,-5h1.5v0.5h-1.5zM3.5,-5h1.5v0.5h-1.5zM3,-4.5h2v0.5h-2zM0.5,-4h4v0.5h-4zM1.5,-3.5h2v0.5h-2zM1.5,-3h1.5v1.5h-1.5zM2,-1.5h1v1.5h-1z',
    },
    {
      paint: 'cherryPetalPink',
      d: 'M2,-7.5h0.5v1h-0.5zM2,-6.5h1v0.5h-1zM3.5,-6.5h0.5v0.5h-0.5zM1,-6h3v0.5h-3zM1.5,-5.5h2.5v0.5h-2.5zM2,-5h1.5v0.5h-1.5zM2,-4.5h1v0.5h-1z',
    },
    {
      paint: 'epicGold',
      d: 'M-0.5,-3.5h1v0.5h-1zM-1,-3h0.5v0.5h-0.5zM0,-3h0.5v0.5h-0.5zM-1,-2.5h1.5v1h-1.5zM3.5,-2.5h1v0.5h-1zM3.5,-2h0.5v0.5h-0.5zM4.5,-2h0.5v0.5h-0.5zM-0.5,-1.5h1v2h-1zM3.5,-1.5h1.5v2h-1.5z',
    },
    { paint: 'trunk', d: 'M-0.5,-3h0.5v0.5h-0.5zM4,-2h0.5v0.5h-0.5z' },
    {
      paint: 'fish',
      d: 'M-0.5,-5h0.5v0.5h-0.5zM1.5,-5h0.5v0.5h-0.5zM-1,-4.5h3v0.5h-3zM-1,-4h1.5v0.5h-1.5z',
    },
    {
      paint: 'epicCrystal',
      d: 'M-4.5,-0.5h0.5v0.5h-0.5zM-5,0h1v0.5h-1zM2,0h0.5v0.5h-0.5zM1.5,0.5h1v0.5h-1z',
    },
  ],
  pixels: 360,
};
export const sprites: readonly PixelSprite[] = [variant0];
